/**
 * CoinBalance — the user's coin balance, shown in the header.
 *
 * Mounting it issues the wallet read that materialises the free tier's daily
 * top-up, so it is rendered for every authenticated user.
 */

import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useWalletStore } from '@/stores/walletStore'
import { PixelIcon } from '@/components/low/PixelIcon'

export function CoinBalance() {
  const { t } = useTranslation()
  const balance = useWalletStore((s) => s.balance)
  const refresh = useWalletStore((s) => s.refresh)

  useEffect(() => {
    refresh()
  }, [refresh])

  if (balance === null) {
    return <div className="min-h-[44px] w-24 bg-muted animate-pulse" />
  }

  return (
    <Link
      to="/profile/coins"
      title={t('billing.coinBalance')}
      className="min-h-[44px] px-4 py-2 bg-card border-2 border-input rounded-none flex items-center gap-2 font-display text-sm font-bold text-foreground pixel-press hover:bg-accent transition-none"
    >
      <PixelIcon>💎</PixelIcon>
      <span className={balance < 0 ? 'text-destructive' : undefined}>{balance}</span>
    </Link>
  )
}
